// extracted by mini-css-extract-plugin
module.exports = {"containerHolder":"SliderContainer_containerHolder__1VQtD"};